export default "__VITE_ASSET__d7f587f0__"